import { SET_CONTACT_RECORDS_CURRENT_PAGE } from '../actions/actionTypes';

const initialState = {
  currentPage: 0,
};

const contactRecordsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CONTACT_RECORDS_CURRENT_PAGE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default contactRecordsReducer;
